import React, { useCallback, useState } from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch } from 'react-redux';

import { roleChoiceSet } from 'reducers/user';
import { useSmallScreen } from 'utils/hooks';
import { RoleNames } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import { TunnelStep } from '../common';
import { CheckboxLabel, SubmitButton } from 'components';
import { LargeChoice, MobileChoice } from './common-components/Choice';
import { Box, Grid, Typography } from '@mui/material';

import PP from 'assets/images/personne_physique.jpg';
import PM from 'assets/images/personne_morale.jpg';

const choices = [
    {
        image: PP,
        label: texts.PERSONNE_PHYSIQUE,
        title: texts.PERSONNE_PHYSIQUE,
        content: texts.PP_TEXT,
        value: RoleNames.PP_PROFESSIONNEL,
    },
    {
        image: PM,
        label: texts.PERSONNE_MORALE,
        title: texts.PERSONNE_MORALE,
        content: texts.PM_TEXT,
        value: RoleNames.PM_PROFESSIONNEL,
    },
];

const RoleSelect = props => {
    const { setRoleSubmitted, roleChoice, subtitle, title, isIndirect } = props;
    const isMobile = useSmallScreen('sm');
    const dispatch = useDispatch();
    const [submitDisclaimerChecked, setSubmitDisclaimerChecked] = useState(false);

    const handleChange = useCallback(
        value => () => {
            dispatch(roleChoiceSet(value));
        },
        [dispatch]
    );

    const handleDisclaimerChange = useCallback(
        event => {
            setSubmitDisclaimerChecked(event.target.checked);
        },
        [setSubmitDisclaimerChecked]
    );

    const handleSubmit = useCallback(() => {
        setRoleSubmitted(true);
    }, [setRoleSubmitted]);

    return (
        <TunnelStep maxWidth={1070} title={title} subtitle={subtitle} height="100%" overflow="auto">
            <Grid
                container
                alignItems="center"
                justifyContent="center"
                sx={{ maxWidth: '1050px', margin: '0 auto 30px' }}
                spacing={0}
                gap={3}
            >
                {choices.map((choice, idx) =>
                    isMobile ? (
                        <MobileChoice
                            key={`${choice.label}-${idx}`}
                            label={choice.label}
                            handleChange={handleChange(choice.value)}
                            title={choice.title}
                            selected={roleChoice === choice.value}
                            content={choice.content}
                            selectType="role"
                            backgroundImage={choice.image}
                        />
                    ) : (
                        <LargeChoice
                            key={`${choice.label}-${idx}`}
                            label={choice.label}
                            handleChange={handleChange(choice.value)}
                            title={choice.title}
                            selected={roleChoice === choice.value}
                            content={choice.content}
                            selectType="role"
                            backgroundImage={choice.image}
                        />
                    )
                )}
            </Grid>
            <Box display="flex" justifyContent="center" flexWrap="wrap" gap={1}>
                <Typography variant="subtitle1" align="center">
                    {texts.SUIVANT_INFO_MESSAGE}
                </Typography>
                <CheckboxLabel
                    sx={{ mb: 0 }}
                    onChange={handleDisclaimerChange}
                    checked={submitDisclaimerChecked}
                    label={texts.SUIVANT_CHECKBOX_MESSAGE}
                />
            </Box>
            <SubmitButton
                text={texts.SUIVANT}
                disabled={!!roleChoice === false || (!submitDisclaimerChecked && !isIndirect)}
                onClick={handleSubmit}
            />
        </TunnelStep>
    );
};

RoleSelect.propTypes = {
    roleChoice: PropTypes.string,
    title: PropTypes.string,
    setRoleSubmitted: PropTypes.func,
    subtitle: PropTypes.node,
    isIndirect: PropTypes.bool,
};

export { RoleSelect };
